import { Button, Typography } from '@mui/material';
import ResponsiveLayout from '../../layout/responsive-layout';
import { useNavigate } from 'react-router-dom';

const AppError = () => {
  const nav = useNavigate();
  return (
    <ResponsiveLayout>
      <div>
        <Typography variant="h4" my={2}>
          Oops! Something went wrong.
        </Typography>
        <Typography mb={6}>
          An unexpected error occured. If this continues please contact
          support@optionsai.com
        </Typography>

        <Button
          variant="contained"
          onClick={() => {
            nav('/dashboard');

            setTimeout(() => {
              window.location.reload();
            }, 300);
          }}
        >
          Reload Page
        </Button>
      </div>
    </ResponsiveLayout>
  );
};

export default AppError;
